import React, { useEffect, useContext } from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";

import { bindActionCreators, Dispatch } from "redux";

import { Dialog as DialogComponent, OkButton } from "@plex/react-components";

import { Banner } from "ui/app";
import { DialogContainer, DialogContext } from "ui/app/navigation/dialog";

import { TranslationsHistoryFilter, TranslationsHistoryGrid } from "./components";
import { translationHistoryActions } from "./TranslationHistory.actions";
import { ITranslationHistoryState } from "./TranslationHistory.state";

interface ITranslationHistoryProps {
  state: ITranslationHistoryState;
  termId: string;
  initTranslationHistory: (termId: string) => void;
  loadTranslationHistory: () => void;
  clearState: () => void;
}

const TranslationsHistory: React.FC<ITranslationHistoryProps & RouteComponentProps> = ({ state, match, initTranslationHistory, loadTranslationHistory, clearState }) => {
  const termId = match && match.params["termId"];
  const dialogContext = useContext(DialogContext);

  useEffect(() => {
    initTranslationHistory(termId);
    loadTranslationHistory();
  }, [initTranslationHistory, loadTranslationHistory, termId]);

  const mainContent = (
    <>
      <Banner messages={state.notifications} />
      <TranslationsHistoryFilter />
      <TranslationsHistoryGrid state={state} />
    </>
  );

  return (
    <>
      <DialogContainer
        onHidden={clearState}
        render={dialogProps => {
          return (
            <DialogComponent {...dialogProps}>
              <DialogComponent.Body>{mainContent}</DialogComponent.Body>
              <DialogComponent.Footer>
                <OkButton onClick={dialogProps.onHide} />
              </DialogComponent.Footer>
            </DialogComponent>
          );
        }}
      />
      {!dialogContext.isOpened && mainContent}
    </>
  );
};

export default connect(
  (state: { translationHistory: ITranslationHistoryState }) => {
    return {
      state: state.translationHistory
    };
  },
  (dispatch: Dispatch) =>
    bindActionCreators(
      {
        initTranslationHistory: translationHistoryActions.initTranslationHistory,
        loadTranslationHistory: translationHistoryActions.loadTranslationHistory,
        clearState: translationHistoryActions.clearState
      },
      dispatch
    )
)(TranslationsHistory);
